import React from "react";
import styles from "./info-icon-and-text.module.scss";
import infoIconFilled from "@src/assets/svg/info-icon-filled.svg";
import { useI18N } from "@src/language/language-context";

interface InfoIconAndTextPropTypes {
  text: string;
}

const cssClassName = "info-icon-and-text";

export const InfoIconAndText = ({ text }: InfoIconAndTextPropTypes) => {
  const i18n = useI18N();
  const texts = {
    infoIconAndTextAltText: i18n(
      "modules.infoIconAndText.infoIconAndTextAltText",
    ),
  };
  return (
    <div className={styles[cssClassName]}>
      <img
        className={styles[`${cssClassName}__icon`]}
        src={infoIconFilled}
        alt={texts.infoIconAndTextAltText}
      />
      <p className={styles[`${cssClassName}__text`]}>{text}</p>
    </div>
  );
};
